// Vendor imports
const PropTypes = require('prop-types')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { CheckExperiment } = require('client-v2/common/containers/rollouts')
// Experiment imports
const TopCallToActionExperimentA = require('./experiments/a/component')
const TopCallToActionExperimentB = require('./experiments/b/component')
const TopCallToActionExperimentC = require('./experiments/c/component')

function TopCallToAction(props) {
  return tag(CheckExperiment, {
    experimentKey: '*logged_out_top_cta',
    renderWithModifier: modifier => {
      if (modifier === 'c') {
        return tag(TopCallToActionExperimentC, props)
      }
      if (modifier === 'b') {
        return tag(TopCallToActionExperimentB, props)
      }
      return tag(TopCallToActionExperimentA, props)
    }
  })
}

TopCallToAction.propTypes = {
  onFoldHeightChange: PropTypes.func.isRequired
}

module.exports = TopCallToAction
